module.exports = __webpack_public_path__ + "media/images/official/about_yamori_uenohara-89f134a724b0bcecc702798fef5b5eb5.png";